import LoginPage from "@/pages/login";
import { Routes } from "./routes";
import SignUpPage from "@/pages/signUp";
import PasswordSend from "@/pages/passwordSend";
import PasswordReset from "@/pages/passwordReset";
import Lisence from "@/pages/lisence";
import ErrorScreen from "@/pages/errorScreen";

export const PublicPath = [
  { path: Routes.LOGIN, element: <LoginPage /> },
  { path: Routes.SIGN_UP, element: <SignUpPage /> },
  { path: Routes.PASSWORD_SEND, element: <PasswordSend /> },
  { path: Routes.PASSWORD_RESET, element: <PasswordReset /> },
  { path: Routes.LISENCE, element: <Lisence /> },
  { path: Routes.ERROR, element: <ErrorScreen /> },
];
